import AOS from 'aos';

function modifyFeatureLineup() {
  $('.featureLineupContainer').each((_, element) => {
    const title = $(element).find('.featureLineup-title');
    let titleText = title.text().trim();
    if (titleText.length > 45) {
      title.text(`${titleText.substring(0, 45)}...`);
      // add a tooltip to the title with the full text
      title.attr('title', titleText);
      titleText = `${titleText.substring(0, 45)}...`;
    } else {
      title.text(titleText);
    }
    $(element).find('.featureLineup-buynow a.button').addClass('buyNowButton');
    $(element)
      .find('.featureLineup-more .button, .featureLineup-headline')
      .addClass('buttonSmall')
      .removeClass('button');
    const description = $(element).find('.featureLineup-text').eq(1);
    const descriptionText = description.text();
    description.empty();
    description.html(
      `<div class="featureLineup-description"><h4 title="${title.text()}">${titleText}</h4> ${descriptionText}</div>`
    );
  });
}

function modifyBtnNavToggle() {
  const navToggle = document.querySelector('.mobile-nav-toggle');

  navToggle.innerHTML = `
    <span></span>
    <span></span>
    <span></span>
  `;
  navToggle.setAttribute('tabindex', '0');
  navToggle.setAttribute('role', 'button');
  navToggle.setAttribute('aria-label', 'open menu');
}

function applyAOS(items, effect) {
  const delayIncrement = 150;
  let currentDelay = 400;
  items.each(function () {
    $(this).attr({
      'data-aos': effect,
      'data-aos-easing': 'ease-in-out',
      'data-aos-duration': '400',
      'data-aos-once': 'false',
    });
    if (items.length === 1) {
      $(this).attr('data-aos-delay', currentDelay.toString());
    } else {
      $(this).attr('data-aos-delay', currentDelay.toString());
      currentDelay += delayIncrement;
    }
  });
}
window.applyAOS = applyAOS;


$(document).ready(() => {
  // Prepend General Message Banner to Header
  $('.generalmessage').prependTo('header');

  modifyFeatureLineup();
  modifyBtnNavToggle();

  const seoSection = $('.seo-section');
  seoSection.prepend('<div class="overlay"></div><div class="polygon"></div>');

  applyAOS($('.video-section .container'), 'zoom-in');

  const searchInput = $('#headerNav_uc_widgetContainer_ctl03_ctl00_SearchBox1_tbx_searchBox');
  // set a placeholder to searchInput
  searchInput.attr('placeholder', 'Type here...');
});

$(window).load(() => {
  // ---
  AOS.init();
});

